module.exports = __webpack_public_path__ + "img/unit_measure.b0cdc460.png";